import styled from 'styled-components';

export const CustomSourceHandle = styled.div``;
